/**
 * 游戏图标地址 → 能直接塞进 `<img src>` 的地址。**纯函数**。
 *
 * 后台存的是两种之一（见 db/migrations/versions/0016_game_icon.py）：
 *
 *     https://cdn.example.com/x.png    原样用
 *     /lobby-icons/fortune_rabbit.png  按**游戏客户端的源**拼
 *
 * 为什么是游戏客户端的源、不是大厅自己的：图标是游戏素材，
 * 和游戏包由同一个地方发（运维铺游戏包时顺手铺图标）。
 * 大厅是另一个源 —— 按大厅拼的话，每一张都是 404。
 *
 * 认不出来的一律 null，**卡片回到占位**，不去猜。后台那边也拦过一道，
 * 这里再判一次是因为这串东西最后落进 DOM：`javascript:`、`data:`、
 * 协议相对的 `//外站` 都不该从这儿进来。
 */
export function iconUrl(icon: string | null | undefined, gameBase: string): string | null {
  const v = (icon ?? '').trim();
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return safe(v);
  if (v.startsWith('/') && !v.startsWith('//')) {
    try {
      return safe(new URL(v, gameBase).toString());
    } catch {
      return null;
    }
  }
  return null;
}

function safe(u: string): string | null {
  try {
    const p = new URL(u);
    return p.protocol === 'https:' || p.protocol === 'http:' ? p.toString() : null;
  } catch {
    return null;
  }
}
